import * as React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { isNilOrEmpty } from 'packages/core'
import moment from 'moment'
import { MUIDatePicker, MUITimePicker } from 'packages/eid-ui/DateTimePickers'

export interface EndDateControlProps {
    selectedStartDate: any
    selectedEndDate: any
    setSelectedEndDate: any
    maxEndDate?: any
    hasInvalidDates: any
    disabled?: boolean
}

export const EndDateControl: React.FC<EndDateControlProps> = ({
    selectedStartDate,
    selectedEndDate,
    setSelectedEndDate,
    maxEndDate,
    hasInvalidDates,
    disabled,
}) => {
    const { t } = useTranslation()

    return (
        <Box
            display="flex"
            style={{
                borderBottom: hasInvalidDates ? '1px solid red' : '',
                opacity: disabled ? '.5' : '1',
            }}
        >
            <MUIDatePicker
                dateFormat="L"
                minDate={selectedStartDate.clone().local()}
                maxDate={maxEndDate?.clone().local()}
                value={
                    isNilOrEmpty(selectedEndDate)
                        ? null
                        : selectedEndDate.clone().local()
                }
                handleChange={(e: any) => {
                    if (isNilOrEmpty(e)) {
                        setSelectedEndDate(null)
                    } else {
                        const date = moment(e)
                        const dateToSet = date
                            .clone()
                            .endOf('day')
                            .set('milliseconds', 0)
                        setSelectedEndDate(dateToSet)
                    }
                }}
                disabled={disabled}
                label={t('Common_EndDate')}
                fieldProps={{ sx: { width: '50%' } }}
            ></MUIDatePicker>
            <MUITimePicker
                value={
                    isNilOrEmpty(selectedEndDate)
                        ? null
                        : selectedEndDate.clone().local()
                }
                handleChange={(e: any) => {
                    const time = moment(e, 'HH:mm')
                    let dateToSet

                    if (!isNilOrEmpty(selectedEndDate)) {
                        dateToSet = selectedEndDate
                    } else {
                        dateToSet = moment()
                    }

                    dateToSet.set({
                        hour: time.hour(),
                        minute: time.minute(),
                        second: 0,
                    })

                    setSelectedEndDate(dateToSet)
                }}
                disabled={disabled}
                label={t('Common_EndTime')}
                timeFormat="LT"
                fieldProps={{ sx: { width: '50%' } }}
            ></MUITimePicker>
        </Box>
    )
}
